export default [
  "Historia PHEV",
  "Wersje wyposażenia",
  "Zaawansowana technologia",
  "Jazda próbna"
];
